import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { DepositRightSectionWrapper } from "./styles";
import { MView } from "../../../styles/mobilePageStyles";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { goTo } from "../../hooks/navigation";
import styled from "styled-components";

const WithdrawRightSection = () => {
  const { textsilver, descBox } = useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const nav = useNavigate();
  return (
    <ModernInfoCard isDarkMode={isDarkMode}>
      <InfoHeader>
        <InfoTitle isDarkMode={isDarkMode}>{t("important")}</InfoTitle>
      </InfoHeader>

      <InfoContent>
        <InfoText isDarkMode={isDarkMode}>
          {t("depositFirstDesc")}
        </InfoText>
        <InfoText isDarkMode={isDarkMode}>
          {t("depositSecondDesc")}
        </InfoText>
        <InfoText isDarkMode={isDarkMode}>
          {t("depositFourthDesc")}
        </InfoText>
      </InfoContent>
    </ModernInfoCard>
  );
};

// Styled Components
const ModernInfoCard = styled.div<{ isDarkMode: boolean }>`
  background: ${props => props.isDarkMode
    ? 'linear-gradient(145deg, rgba(60, 60, 60, 0.8) 0%, rgba(45, 45, 45, 0.9) 100%)'
    : '#F0F1F8'      // theme.light.COLORS.CardBg
  };
  border-radius: 16px;
  padding: 24px;
  border: 1px solid ${props => props.isDarkMode
    ? 'rgba(255, 255, 255, 0.15)'
    : '#C8D6EF'      // theme.light.COLORS.CardBorder
  };
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  height: fit-content;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.isDarkMode
      ? '0 8px 25px rgba(0, 0, 0, 0.4)'
      : '0 8px 25px rgba(0, 0, 0, 0.08)'
    };
    border-color: ${props => props.isDarkMode
      ? 'rgba(0, 122, 255, 0.4)'
      : 'rgba(0, 122, 255, 0.5)'
    };
  }
`;

const InfoHeader = styled.div`
  margin-bottom: 20px;
`;

const InfoTitle = styled.h3<{ isDarkMode: boolean }>`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${props => props.isDarkMode ? '#FFFFFF' : '#212121'};  // theme.light.COLORS.itemTitle
  position: relative;
  padding-bottom: 12px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #007AFF 0%, #33A7FF 100%);
    border-radius: 2px;
  }
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoText = styled.p<{ isDarkMode: boolean }>`
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: ${props => props.isDarkMode ? '#B8BCC8' : '#616161'};  // theme.light.COLORS.itemContent
  opacity: 0.9;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default WithdrawRightSection;
